export default __webpack_public_path__ + "add-user-sm.672f57d6.svg";